import { createBrowserRouter } from "react-router-dom";
import Home from '../pages/Home';
import Authentication from '../pages/Authentication';
import { ROUTER } from "./constants";
import Enter from '../pages/Enter';
import Room from '../pages/Room';
import Date from "../pages/Date";
import Time from "../pages/Time";
import ReservationConfirmation from "../pages/ReservationConfirmation";
import Setting from "../pages/Setting";
import Systems from "../pages/Systems";
import Payment from "../pages/Payment";
import SettingRoom from "../pages/SettingRoom";
import BookingTracking from "../pages/BookingTracking";

const router = createBrowserRouter([
    {
        path: ROUTER.HOME,
        element: <Home />,
    },
    {
        path: ROUTER.AUTHENTICATION,
        element: <Authentication />,
    },
    {
        path: ROUTER.ENTER,
        element: <Enter />,
    },
    {
        path: ROUTER.ROOM,
        element: <Room />,
    },
    {
        path: ROUTER.RESERVE_ROOM_DATE,
        element: <Date />,
    },
    {
        path: ROUTER.RESERVE_ROOM_TIME,
        element: <Time />,
    },
    {
        path: ROUTER.RESERVE_CONFIRM,
        element: <ReservationConfirmation />,
    },
    {
        path: ROUTER.SETTING,
        element: <Setting />,
    },
    {
        path: ROUTER.SYSTEMS,
        element: <Systems />,
    },
    {
        path: ROUTER.PAYMENT,
        element: <Payment />,
    },
    {
        path: ROUTER.SETTING_ROOM,
        element: <SettingRoom />,
    },
    {
        path: ROUTER.BOOKING_TRACKING,
        element: <BookingTracking />,
    }
])

export default router